/**
 * Copyright (c) 2025 eBUCIS, LLC. All rights reserved.
 *
 * Version Configuration
 *
 * This software is proprietary and confidential. Unauthorized copying,
 * distribution, or modification is strictly prohibited.
 */

// Version values are injected at build time via Vite define
// These placeholders are replaced during the build process
export const versionConfig = {
  // Build ID serves as the version identifier (format: YYYYMMDD.HHMMSS)
  // String comparison works for chronological ordering
  buildId: typeof __BUILD_ID__ !== 'undefined' ? __BUILD_ID__ : 'development',

  // Build timestamp (injected at build time)
  buildTime: typeof __BUILD_TIME__ !== 'undefined' ? __BUILD_TIME__ : new Date().toISOString(),

  // Enable/disable version checking
  enabled: import.meta.env.VITE_VERSION_CHECK_ENABLED !== 'false',

  // Version check interval when user is AUTHENTICATED (less frequent - don't interrupt)
  // Default: 10 minutes
  authenticatedCheckInterval:
    parseInt(import.meta.env.VITE_VERSION_CHECK_INTERVAL_AUTH) || 10 * 60 * 1000,

  // Version check interval when user is NOT authenticated (more frequent - can update freely)
  // Default: 2 minutes
  unauthenticatedCheckInterval:
    parseInt(import.meta.env.VITE_VERSION_CHECK_INTERVAL_UNAUTH) || 2 * 60 * 1000,

  // Minimum time between any checks (prevents excessive requests)
  // Default: 30 seconds
  minCheckInterval: parseInt(import.meta.env.VITE_VERSION_MIN_CHECK_INTERVAL) || 30 * 1000,

  // Legacy: General check interval (used as fallback)
  checkInterval: parseInt(import.meta.env.VITE_VERSION_CHECK_INTERVAL) || 5 * 60 * 1000,

  // Endpoint for version check
  endpoint: '/meta.json'
}

export default versionConfig
